import api from '~api'
import moment from 'moment'
import {
  convertPages,
} from '~utils/api'

export const url = `/event`

export async function getStudentPointByEventType (params) {
  const {
    data
  } = await api.get(`${url}/GetStudentPointByEventType`, {
    params
  })
  
  const obtainRecord = data.data.map((record) => {
    return {
      event_start_date: moment(record.eventStartDate).isValid() ? moment(record.eventStartDate).format('YYYY/MM/DD') : "",
      event_end_date: moment(record.eventEndDate).isValid() ? moment(record.eventEndDate).format('YYYY/MM/DD')  : "",
      check_in_date: moment(record.checkInData).isValid() ? moment(record.checkInData).format('YYYY/MM/DD HH:mm')  : "",
      event_start_time: record.eventStartTime,
      event_end_time: record.eventEndTime,
      mentor_name: record.mentor_name,
      mentor_unit: record.mentor_unit,
      event_name: record.description,
      record_amount: record.amount,
    }
  })

  return {
    obtainRecord,
    obtainLimit: data.limit,
  }
}

export async function getStudentTradeList (params) {
  const {
    data
  } = await api.get(`${url}/GetStudentTradeList`, {
    params
  })
  
  const exchangeRecord = data.map((record) => {
    return {
      record_date: moment(record.created_at).format('YYYY/MM/DD'),
      record_time: moment(record.created_at).format('HH:mm'),
      record_trade_events_name: record.trade_events_name,
      record_name: record.name,
      record_cost: record.cost,
    }
  });

  return {
    exchangeRecord,
  }
}

export async function getTradeEvent () {
  const {
    data
  } = await api.get(`${url}/GetTradeEvent`)
  
  const tradeEvents = data.map((trade_event) => {
    return {
      event_id: trade_event.id,
      event_start_date: moment(trade_event.event_start_date).format('YYYY/MM/DD'),
      event_end_date: moment(trade_event.event_end_date).format('YYYY/MM/DD'),
      event_squad: trade_event.event_squad,
      event_name: trade_event.name,
      multiple_enable: trade_event.multiple_enable,
      trade_start_date: moment(trade_event.trade_start_date).format('YYYY/MM/DD'),
      trade_end_date: moment(trade_event.trade_end_date).format('YYYY/MM/DD'),
    }
  });

  return {
    tradeEvents,
  }
}

export async function getEventCanTradeList (params) {
  const {
    data
  } = await api.get(`${url}/GetEventCanTradeList`, {
    params
  })
  
  const eventCanTradeList = data.map((item) => {
    return {
      item_name: item.name,
      item_cost: item.cost,
      item_note: item.note,
    }
  });

  return {
    eventCanTradeList,
  }
}

export async function getStudentPointListByEvent (params) {
  const {
    data
  } = await api.get(`${url}/GetStudentPointListByEvent`, {
    params
  })
  
  const studentPointList = Object.keys(data.data).map(squad_name => {
    const squad = data.data[squad_name][params.student_id];
    if(!squad) {
      return { squad_total: 0, squad_point_list: [] };
    }
    const squad_point_list = squad.data.map(point_record => {
      return {
        event_start_date: moment(point_record.eventStartDate).format('YYYY/MM/DD'),
        event_end_date: moment(point_record.eventEndDate).format('YYYY/MM/DD'),
        event_start_time: point_record.eventStartTime,
        event_end_time: point_record.eventEndTime,
        description: point_record.description,
        amount: point_record.amount,
      }
    });
    return {
      squad_total: squad.total,
      squad_point_list,
    }
  });
  
  return {
    allEventSquadTotal: data.allEventSquadTotal,
    studentPointList,
  }
}

export async function createStudentPointByQRCode (params) {
  const {
    data
  } = await api.post(`${url}/createStudentPointByQRCode`, {
    params
  })
  
  return data;
}